import {
  Table,
  TableCell,
  TableRow,
  TableBody,
  TableHead,
  Grid,
  TableContainer,
  Typography,
} from "@material-ui/core";
import * as MuiIcon from "@material-ui/icons";
import React from "react";

const AccessbilitiesTable = ({ lists }) => {
  return (
    <Grid item container xs={12} spacing={2} style={{ margin: "auto" }}>
      <Grid item xs={12}>
        <Typography variant="body1">منو</Typography>
      </Grid>
      <Grid item xs={12}>
        <TableContainer style={{}}>
          <Table>
            <TableHead></TableHead>
            <TableBody>
              {lists.map((item, i) => (
                <TableRow key={i}>
                  <TableCell width="40%">{item.title}</TableCell>
                  <TableCell>{GenerateIcon(item.status)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};

export default AccessbilitiesTable;

const GenerateIcon = (variation, props = {}) => {
  const IconName = MuiIcon[variation];
  return (
    <IconName
      {...props}
      style={{ color: variation === "Done" ? "green" : "red" }}
    />
  );
};
